import { PIXELS_IN_PLOT_SECOND } from 'utils/constants';

type Payload = {
  samples: number[];
  sampleRate: number;
};

const getPlotWidth = (data: Payload | undefined) => {
  if (!data) {
    return 0;
  }
  const sampleDuration = data.samples.length / data.sampleRate;

  return sampleDuration * PIXELS_IN_PLOT_SECOND;
};

export { getPlotWidth };
